module.exports = __webpack_public_path__ + "img/box_white.f8c1c287.webp";